// extracted by mini-css-extract-plugin
export default {"navbar-height":"3.25rem","content":"Ci0H4","fullHeight":"myXlK","fullscreen":"bNDob"};